import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-shared-icon-button',
  templateUrl: './shared-icon-button.component.html',
  styleUrls: ['./shared-icon-button.component.scss'],
})
export class SharedIconButtonComponent {
  @Input() icon?: string;
  @Input() icon_class?: string;
  @Input() button_class: string = 'hmn-icon__button-main';
  @Output() button_click: EventEmitter<void> = new EventEmitter<void>();
}
